import { CliError } from "../../lib/cli/cli-error";
import { catalogTopics } from "@/commands/catalog/catalog-topics";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

/**
 * Read before creating a session: a repository outside `repos` is refused at
 * creation, and a model outside `models` is not routable.
 */
export async function catalogCommand(
  topic: string,
  parsed: ParsedArgs,
): Promise<void> {
  const list = catalogTopics[topic];
  if (!list) {
    throw new CliError(`Unknown catalog topic "${topic}".`, 2);
  }
  await list(parsed, parsed.booleans.has("json"));
}
